"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Traumabehandlung",
  description: "Sanfte und tiefgreifende Begleitung zur Auflösung alter Wunden. Finde zurück zu emotionaler Klarheit und innerem Frieden.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/healing_stone_trauma.png",
  link: "/AngebotePage#koerper"
}, {
  title: "Energiearbeit",
  description: "Löse Deine Blockaden und bringe Deine  Lebensenergie wieder in den Fluss. Für ein geerdetes, kraftvolles und authentisches Sein.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/healing_stone_energy.png",
  link: "/AngebotePage"
}, {
  title: "Meditation & Achtsamkeit",
  description: "Geführte Praktiken für mehr Präsenz im Alltag. Reduziere Stress und stärke Deine  innere Balance nachhaltig.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/healing_stone_meditation.png",
  link: "/AngebotePage"
}];
export default function HealingMethods() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="methoden-der-heilung" className="py-24 md:py-32 bg-background overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl" ref={ref}>
        <div className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-serif text-4xl md:text-5xl text-center text-foreground mb-16 md:mb-24 tracking-tight">
            Methoden der Heilung
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {services.map((service, i) => <div key={i} data-index={i} className="group h-full">
                <Card className="text-card-foreground gap-6 h-full border border-border/40 p-8 transition-all duration-500 flex flex-col rounded-2xl !bg-[hsl(251,91%,95%)] md:p-10 hover:-translate-y-2 hover:shadow-2xl hover:shadow-primary/15 hover:border-primary/30">
                  <div className="mb-8">
                    <img src={`${service.image}`} alt={`${service.title} stone`} className="object-contain transition-transform duration-500 group-hover:scale-110 !rounded-xl !w-[100px] !h-[100px]" />
                  </div>
                  
                  <h3 className="font-serif text-2xl text-foreground mb-4">
                    {service.title}
                  </h3>
                  
                  <p className="text-muted-foreground leading-relaxed flex-grow mb-8 text-base">
                    {service.description}
                  </p>
                  
                  <Link to={service.link}>
                    <Button className="w-full md:w-auto bg-primary text-primary-foreground hover:bg-primary/90 transition-colors">
                      Mehr erfahren
                    </Button>
                  </Link>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}